<p-toast position="bottom-right"></p-toast>

<p-dialog
    [(visible)]="displayDialog"
    [style]="{ width: '800px' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="close()"
    header="Agenda del Gestor"
>
    <form [formGroup]="form" (ngSubmit)="save()" appPermissionControl="P265F0001">
        <div class="form-row">
            <div class="form-field">
                <p-dropdown 
                    formControlName="agenda" 
                    [options]="agendas" 
                    optionLabel="descripcion" 
                    appendTo="body"
                    optionValue="valor"
                    [filter]="true"
                    placeholder="Seleccione una agenda"
                    class="w-100" appPermissionControl="P265K0001">
                </p-dropdown>
                <label>Agenda</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <input pInputText type="number" formControlName="prioridad" class="form-control" 
                    [placeholder]="'Ingrese prioridad'" 
                    min="0" appPermissionControl="P265K0002">
                <label>Prioridad</label>
            </div>
        </div>

        <div class="button-section">
            <button *ngIf="isEditing" mat-flat-button class="btn-delete btn-menu" type="button" (click)="cancelEdit()" appPermissionControl="P265B0001">
                <mat-icon>cancel</mat-icon>
                Cancelar
            </button>
            <button mat-flat-button class="btn-success btn-menu" (click)="save()"
                [disabled]="!form.valid || loading" appPermissionControl="P265B0002">
                <mat-icon>{{ isEditing ? 'update' : 'save' }}</mat-icon>
                {{ isEditing ? 'Actualizar' : 'Guardar' }}
            </button>
        </div>
    </form>

    <!-- Tabla de items de agenda -->
    <div class="table-section mt-4">    
        <p-table
            [value]="agendaItems" 
            [paginator]="true" 
            [rows]="10"
            [showCurrentPageReport]="true"
            appendTo="body"
            [rowsPerPageOptions]="[5, 10, 20]"
            [scrollable]="true"
            [scrollHeight]="'200px'"
            styleClass="p-datatable-gridlines"
            [resizableColumns]="true"
            [autoLayout]="true"
            responsiveLayout="scroll"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} items"
         appPermissionControl="P265T0001">
            <ng-template pTemplate="header">
                <tr>
                    <th class="th-prime" appPermissionControl="P265C0001">Descripción</th>
                    <th class="th-prime" appPermissionControl="P265C0002">Prioridad</th>
                    <th class="th-prime" style="width: 120px;" appPermissionControl="P265C0003">Acciones</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td class="td-prime">{{ item.descripcion }}</td>
                    <td class="td-prime">{{ item.prioridad }}</td>
                    <td class="td-prime">
                        <div class="d-flex gap-2 justify-content-center">
                            <button
                                pButton
                                icon="pi pi-eye"
                                class="p-button-rounded p-button-info p-button-text"
                                (click)="viewItem(item)"
                                pTooltip="Ver"
                             appPermissionControl="P265B0003"></button>
                            <button
                                pButton
                                icon="pi pi-trash"
                                class="p-button-rounded p-button-danger p-button-text"
                                (click)="deleteItem(item)"
                                pTooltip="Eliminar"
                             appPermissionControl="P265B0004"></button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3" class="text-center td-prime">
                        <span>No hay items de agenda</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-dialog>

<style>
    .form-row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 1rem;
        gap: 1rem;
    }

    .form-field {
        flex: 1 1 calc(50% - 1rem);
        min-width: 200px;
        display: flex;
        flex-direction: column-reverse;
        position: relative;
    }

    .form-control {
        width: 100%;
        padding: 0.5rem;
        font-size: 1rem;
        border: 1px solid #ced4da;
        border-radius: 4px;
        background: #fff;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .form-field label {
        font-size: 0.85rem;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }

    .button-section {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    .table-section {
        margin-top: 1rem;
    }

    .w-100 {
        width: 100%;
    }

    .mt-4 {
        margin-top: 1.5rem;
    }

    .d-flex {
        display: flex;
    }

    .gap-2 {
        gap: 0.5rem;
    }

    .justify-content-center {
        justify-content: center;
    }

    .text-center {
        text-align: center;
    }

    .th-prime {
        background-color: #f8f9fa;
        border: 1px solid #dee2e6;
        padding: 0.75rem;
        font-weight: 600;
        color: #495057;
    }

    .td-prime {
        border: 1px solid #dee2e6;
        padding: 0.75rem;
        vertical-align: middle;
    }
</style> 